import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.purchaseOrders.PurchaseOrderListView.';
  public static readonly allCurrentTabTitle = `${Id.prefix}allCurrentTabTitle`;
  public static readonly draftTabTitle = `${Id.prefix}draftTabTitle`;
  public static readonly issuedTabTitle = `${Id.prefix}issuedTabTitle`;
  public static readonly completedTabTitle = `${Id.prefix}completedTabTitle`;
  public static readonly cancelledTabTitle = `${Id.prefix}cancelledTabTitle`;
}

export class LangPurchaseOrderListView {
  private constructor() {}
  public static allCurrentTabTitle(): string {
    return interpolate(Id.allCurrentTabTitle);
  }
  public static draftTabTitle(): string {
    return interpolate(Id.draftTabTitle);
  }
  public static issuedTabTitle(): string {
    return interpolate(Id.issuedTabTitle);
  }
  public static completedTabTitle(): string {
    return interpolate(Id.completedTabTitle);
  }
  public static cancelledTabTitle(): string {
    return interpolate(Id.cancelledTabTitle);
  }
}

export class PurchaseOrderListViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.allCurrentTabTitle, 'All Current', 'Tab title for all current purchase orders');
    register.add(Id.draftTabTitle, 'Draft', 'Tab title for draft purchase orders');
    register.add(Id.issuedTabTitle, 'Issued', 'Tab title for issued purchase orders');
    register.add(Id.completedTabTitle, 'Completed', 'Tab title for completed purchase orders');
    register.add(Id.cancelledTabTitle, 'Cancelled', 'Tab title for cancelled purchase orders');
  }
}
